import { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import Text from '../../../Components/Text';
import TextInput from '../../../Components/Form/TextInput';
import Button from '../../../Components/Buttons/Button';

const QRCodeScanner = ({ onConfirmAction }) => {
    const qrRef = useRef(null);
    const qrInstance = useRef(null);
    const [code, setCode] = useState('');

    useEffect(() => {
        qrInstance.current = new Html5Qrcode('qr-reader');

        qrInstance.current
            .start(
                { facingMode: 'environment' },
                { fps: 10, qrbox: 250 },
                (decodedText) => {
                    setCode(decodedText);
                }
            )
            .catch(() => { });

        return () => {
            const instance = qrInstance.current;
            if (!instance) return;

            instance
                .stop()
                .then(() => instance.clear())
                .catch(() => {
                });
        };
    }, []);

    return (
        <div className='w-full h-full flex flex-col gap-3'>
            <Text type="main">QR Code scannen</Text>

            <div
                id="qr-reader"
                ref={qrRef}
            />

            <TextInput
                id="codeId"
                label="Aktionscode"
                placeholder="Code manuell eingeben"
                attribute={code}
                action={(e) => setCode(e.target.value)}
            />
            <Button disabled={!code} onClickAction={() => onConfirmAction?.(code)}>Bestätigen</Button>
        </div>
    );
};

export default QRCodeScanner;
